module.exports = __webpack_public_path__ + "static/media/3-4.00156f58.svg";